// extracted by mini-css-extract-plugin
export default {"productDescription":"sda-z","featuredDescription":"tda-z","description":"uda-z","more":"vda-z","descriptionSku":"wda-z"};